module.exports = __webpack_public_path__ + "assets/001f9914b05ba48b3ed0116b0276893f.mp3";